import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { createClient } from '@/api/supabase'
import { USE_MOCK } from '@/config'

/**
 * Подписка на UPDATE одной строки `profiles WHERE id=eq.{inspectorId}`.
 * При апдейте инвалидирует `['inspector-eta', orderId]` — `OrderInspectorEtaBlock`
 * перезапросит позицию через `inspector_position_for_dealer` и пересчитает
 * расстояние/ETA. Канал жив пока виджет смонтирован.
 *
 * Требует: profiles в supabase_realtime publication
 * (миграция `20260504010000_realtime_profiles.sql`).
 */
export function useInspectorEtaRealtime(
  orderId: string | null | undefined,
  inspectorId: string | null | undefined,
) {
  const qc = useQueryClient()

  useEffect(() => {
    if (USE_MOCK) return
    if (!orderId || !inspectorId) return
    const supabase = createClient()
    let cancelled = false
    let cleanup: (() => void) | null = null

    void (async () => {
      const { data: sess } = await supabase.auth.getSession()
      if (cancelled) return
      if (sess.session) {
        supabase.realtime.setAuth(sess.session.access_token)
      }
      const ch = supabase
        .channel(`inspector-eta:${orderId}`)
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'profiles',
            filter: `id=eq.${inspectorId}`,
          },
          () => {
            void qc.invalidateQueries({ queryKey: ['inspector-eta', orderId] })
          },
        )
        .subscribe()
      cleanup = () => {
        void supabase.removeChannel(ch)
      }
    })()

    return () => {
      cancelled = true
      cleanup?.()
    }
  }, [qc, orderId, inspectorId])
}
